var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScratch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_954_4668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 14C1.33328 13.1375 1.54238 12.2878 1.94276 11.5238C2.34313 10.7598 2.92283 10.1043 3.63214 9.61354C4.34145 9.12277 5.15921 8.81136 6.01529 8.70601C6.87138 8.60066 7.74024 8.70451 8.54737 9.00867M14.252 11.084C14.5176 10.8184 14.6668 10.4582 14.6668 10.0827C14.6668 9.70709 14.5176 9.3469 14.252 9.08133C13.9865 8.81576 13.6263 8.66657 13.2507 8.66657C12.8751 8.66657 12.5149 8.81576 12.2494 9.08133L9.57604 11.756C9.41754 11.9144 9.30152 12.1102 9.23871 12.3253L8.68071 14.2387C8.66398 14.296 8.66297 14.3568 8.6778 14.4147C8.69263 14.4726 8.72275 14.5254 8.765 14.5677C8.80726 14.61 8.86009 14.6401 8.91798 14.6549C8.97587 14.6697 9.03667 14.6687 9.09404 14.652L11.0074 14.094C11.2225 14.0312 11.4183 13.9152 11.5767 13.7567L14.252 11.084ZM10 5.33333C10 7.17428 8.50766 8.66667 6.66671 8.66667C4.82576 8.66667 3.33337 7.17428 3.33337 5.33333C3.33337 3.49238 4.82576 2 6.66671 2C8.50766 2 10 3.49238 10 5.33333Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_954_4668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratch);
export default __webpack_public_path__ + "static/media/scratch.c881d2921ef8081db8640b1d424c739a.svg";
export { ForwardRef as ReactComponent };